export enum CaseTypes {
  Camel = 'camel',
  Snake = 'snake',
  Kebab = 'kebab',
}

export type Case = CaseTypes.Camel | CaseTypes.Snake | CaseTypes.Kebab;

export type CaseConverterFn = (data: any) => any;
